import { render, staticRenderFns } from "./ModalSummaryReception.vue?vue&type=template&id=70530b8a&scoped=true&lang=pug&"
import script from "./ModalSummaryReception.vue?vue&type=script&lang=js&"
export * from "./ModalSummaryReception.vue?vue&type=script&lang=js&"
import style0 from "./ModalSummaryReception.vue?vue&type=style&index=0&id=70530b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70530b8a",
  null
  
)

export default component.exports